import https from "./https"
import store from "@/store"

const redeemCode = {
  getRedeemCodes(params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/redeem-codes`, {params})
  },

  exportRedeemCodes(params) {
    const organization = store.state.general.organization
    return https.get(`admin/organizations/${organization.id}/redeem-codes/export`, {params})
  },

  redeemCode(redeemCodeId) {
    const organization = store.state.general.organization
    return https.post(`admin/organizations/${organization.id}/redeem-codes/${redeemCodeId}/redeem`)
  },

  cancelRedeemCode(redeemCodeId) {
    const organization = store.state.general.organization
    return https.post(`admin/organizations/${organization.id}/redeem-codes/${redeemCodeId}/cancel-redeem`)
  }
}

export default redeemCode
